import React, { createContext, useContext, useState, useEffect } from "react";
import { doc, setDoc, getDoc, getDocs, collection } from "firebase/firestore";
import { db, auth } from "../firebase";
import AsyncStorage from "@react-native-async-storage/async-storage";

const ShopContext = createContext();

export const StateContext = ({ children }) => {
  // States
  const [qty, setQty] = useState(1);
  const [cartItems, setCartItems] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [totalQty, setTotalQty] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [currentUser, setCurrentUser] = useState("");
  const [initSession, setInitSession] = useState(false);
  const [userID, setUserID] = useState("");
  const [promoDrn, setPromoDrn] = useState();
  const [promoEro, setPromoEro] = useState();
  const [scroll, setScroll] = useState(true);
  const [admins, setAdmins] = useState([]);
  const [admin, setAdmin] = useState(false);
  const [fullCurrentUser, setFullCurrentUser] = useState("");
  const [lastProd, setLastProd] = useState([]);
  const [fullProducts, setFullProducts] = useState([]);
  const [isViajante, setIsViajante] = useState(false);
  const [correoViajante, setCorreoViajante] = useState("");
  const [productImages, setProductImages] = useState(new Map());

  const ahora = "chespi";

  const IMAGES_CACHE_KEY = "CACHE_PRODUCT_IMAGES";
  const IMAGES_PERIOD_KEY = "CACHE_PRODUCT_IMAGES_PERIOD";
  const getImagesCachePeriod = () => {
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}-${d.getHours() < 12 ? "AM" : "PM"}`;
  };

  useEffect(() => {
    const loadProductImages = async () => {
      try {
        console.log("[Images] Starting loadProductImages...");
        const [cached, cachedPeriod] = await Promise.all([
          AsyncStorage.getItem(IMAGES_CACHE_KEY),
          AsyncStorage.getItem(IMAGES_PERIOD_KEY),
        ]);
        const currentPeriod = getImagesCachePeriod();
        console.log("[Images] Cache period stored:", cachedPeriod, "| current:", currentPeriod);

        if (cached && cachedPeriod === currentPeriod) {
          const parsed = JSON.parse(cached);
          console.log("[Images] Cache hit — entries:", parsed.length);
          if (parsed.length > 0) {
            setProductImages(new Map(parsed));
            return;
          }
          console.log("[Images] Cache is empty, fetching from Firestore...");
        } else {
          console.log("[Images] Cache miss or stale, fetching from Firestore...");
        }

        const snap = await getDocs(collection(db, "productImages"));
        const map = new Map();
        snap.forEach((d) => { if (d.data().url) map.set(d.id, d.data().url); });
        console.log("[Images] Firestore returned:", map.size, "entries");

        if (map.size > 0) {
          await AsyncStorage.setItem(IMAGES_CACHE_KEY, JSON.stringify([...map]));
          await AsyncStorage.setItem(IMAGES_PERIOD_KEY, currentPeriod);
          console.log("[Images] Cache updated.");
        } else {
          console.log("[Images] Firestore empty — skipping cache write.");
        }
        setProductImages(map);
      } catch (e) {
        console.log("[Images] ERROR loading product images:", e.message);
      }
    };
    loadProductImages();
  }, []);

  const history = () => {
    navigation.navigate("Historial");
  };


  useEffect(()=>{
    if(currentUser == "need"){
      //navigate to Seleccionar Cliente
      console.log("need present");
      navigation.navigate("SeleccionarCliente");
    } else {
      console.log("need not present");
    }
  },[currentUser])
  // get doc adminUsers from users in firestore

  // need to check in the AUTH if the user is Viajante base on the photourl and console log that

  // useEffect(() => {
  //   if (auth.currentUser && auth.currentUser.photoURL === "VIAJANTE") {
  //     console.log("is viajante");
  //     setIsViajante(true);
  //   } else {
  //     console.log("is not viajante");
  //     setIsViajante(false);
  //   }
  // }, [auth.currentUser]);


  
  useEffect(() => {
    getDoc(doc(db, "data", "adminUsers")).then((docSnap) => {
      console.log(docSnap.data());
      setAdmins(docSnap.data());
    });
  }, []);

  useEffect(() => {
    if (currentUser != "" && admins != undefined) {
      const clean = currentUser.replace("@mail.com", "");
      console.log("its true because");
      console.log(currentUser);
      console.log(admins);
      setAdmin(admins[clean]);
      console.log("this is the admin");
      console.log(admins[clean]);
    }
  }, [userID]);

  // Save Cart on everychange

  useEffect(() => {
    if (currentUser != "") {
      setDoc(
        doc(db, "users", currentUser),
        {
          currentCart: cartItems,
          currentTotal: totalPrice,
          data: fullCurrentUser,
        },
        { merge: true }
      );
    }
  }, [cartItems]);

  useEffect(() => {
    console.log("this is the scroll");
    console.log(scroll);
  }, [scroll]);

  useEffect(() => {
    console.log(cartItems);
    let nuTot = 0;
    console.log(nuTot);
    for (let i = 0; i < cartItems.length; i++) {
      nuTot = nuTot + cartItems[i].price * cartItems[i].quantity;
    }
    console.log(nuTot);
    console.log(nuTot * 0.9);
  }, [cartItems]);

  useEffect(() => {
    let newTotal = 0;
    for (let i = 0; i < cartItems.length; i++) {
      newTotal += cartItems[i].quantity;
    }
    setTotalQty(newTotal);
  }, [cartItems]);

  // retrieve cart on new session

  useEffect(() => {
    console.log("this is the current user from the useffect");
    console.log(currentUser);
    if (currentUser != "" && !initSession) {
      getDoc(doc(db, "users", currentUser)).then((docSnap) => {
        if (docSnap.exists()) {
          setCartItems(docSnap.data().currentCart);
        } else {
          console.log("No such document!");
        }
      });
    }
  }, [currentUser]);

  // Increase product qty
  const increaseQty = () => {
    setQty((prevQty) => prevQty + 1);
  };

  // Decrease product qty
  const decreaseQty = () => {
    setQty((prevQty) => {
      if (prevQty - 1 < 1) return 1;
      return prevQty - 1;
    });
  };

  //Add Product to Cart

  const onAdd = (product, quantity) => {
    console.log(product);
    //Increase total Qty
    setTotalQty((prevTotal) => prevTotal + quantity);
    //Increase Total Price
    setTotalPrice(
      (prevTotal) => prevTotal + parseInt(product.price) * parseInt(quantity)
    );

    // setTotalPrice((prevTotal) => {
    //   console.log(prevTotal);
    //   let numa = parseInt(product.price) * parseInt(quantity);
    //   parseInt(prevTotal) + numa;
    // });

    console.log(product.price);
    // check if the product is already on the cart
    const exist = cartItems.find((item) => item.sku === product.sku);
    if (exist) {
      setCartItems(
        cartItems.map((item) =>
          item.sku === product.sku
            ? { ...exist, quantity: exist.quantity + quantity }
            : item
        )
      );
    } else {
      setCartItems([...cartItems, { ...product, quantity: quantity }]);
    }
  };

  //Remove qty on cart

  const onRemove = (product) => {
    // //Decrease Total Qty
    // setTotalQty((prevTotal) => prevTotal - 1);
    // //Decrease Total Price
    // setTotalPrice((prevTotal) => prevTotal - product.Price);
    // const exist = cartItems.find((item) => item.sku === product.sku);
    // if (exist.quantity === 1) {
    setCartItems(cartItems.filter((item) => item.sku !== product.sku));
    // } else {
    //   setCartItems(
    //     cartItems.map((item) =>
    //       item.Slug === product.Slug
    //         ? { ...exist, quantity: exist.quantity - 1 }
    //         : item
    //     )
    //   );
    // }
  };

  const onPlus = (i) => {
    setCartItems(
      cartItems.map(
        (product) =>
          product.sku === cartItems[i].sku
            ? { ...product, ...{ quantity: cartItems[i].quantity + 1 } } // Spread to update the specific product
            : product // Leave other products unchanged
      )
    );
  };

  const onMinus = (i) => {
    if (cartItems[i].quantity > 1) {
      setCartItems(
        cartItems.map(
          (product) =>
            product.sku === cartItems[i].sku
              ? { ...product, ...{ quantity: cartItems[i].quantity - 1 } } // Spread to update the specific product
              : product // Leave other products unchanged
        )
      );
    }
  };

  const onForced = (i, qty) => {
    const cantidad = parseInt(qty);
    if (cantidad > 1) {
      setCartItems(
        cartItems.map(
          (product) =>
            product.sku === cartItems[i].sku
              ? { ...product, ...{ quantity: cantidad } } // Spread to update the specific product
              : product // Leave other products unchanged
        )
      );
    }
  };

  useEffect(() => {
    console.log("////////////// FROM CONTEXT //////////////");
    console.log(lastProd);
    console.log(cartItems);
    console.log(isViajante);
    console.log(correoViajante);

    // Only run if cart and lastProd are available
    if (cartItems.length > 0 && lastProd.length > 0) {
      // Create a map for quick lookup of latest products by SKU or ID
      const prodMap = {};
      lastProd.forEach((prod) => {
        // Use the correct unique identifier for your products (sku, ARTICULO__ID, etc.)
        prodMap[prod.sku || prod.ARTICULO__ID] = prod;
      });

      // Update cart items with latest price
      const updatedCart = cartItems.map((item) => {
        const key = item.sku || item.ARTICULO__ID;
        if (prodMap[key]) {
          return {
            ...item,
            price: prodMap[key].PRECIOVENTA || prodMap[key].price || item.price,
          };
        }
        return item;
      });
      console.log("Updated Cart Items:");
      console.log(updatedCart);
      setCartItems(updatedCart);
    }
  }, [lastProd]);
  // EXPORT ALL

  return (
    <ShopContext.Provider
      value={{
        qty,
        increaseQty,
        decreaseQty,
        showCart,
        setShowCart,
        cartItems,
        setCartItems,
        onAdd,
        onRemove,
        onPlus,
        onMinus,
        onForced,
        totalQty,
        totalPrice,
        setQty,
        ahora,
        currentUser,
        setCurrentUser,
        history,
        promoDrn,
        promoEro,
        setPromoDrn,
        setPromoEro,
        scroll,
        setScroll,
        userID,
        setUserID,
        admin,
        setFullCurrentUser,
        fullCurrentUser,
        setLastProd,
        lastProd,
        fullProducts,
        setFullProducts,
        isViajante,
        setIsViajante,
        correoViajante,
        setCorreoViajante,
        productImages,
        setProductImages,
      }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export const useStateContext = () => useContext(ShopContext);
